module.exports = __webpack_public_path__ + "static/home-03a722e63bf4b0ccb74b6660ecd1e90e.webp";